import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const th = { padding: '0 12px 10px 0', color: '#9AA3AE', fontSize: '10.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '10px 12px 10px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };
const inpStyle = { padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const card = { background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '16px 18px', marginBottom: '16px' };
const btn = (bg, disabled) => ({ padding: '8px 16px', background: bg, border: 'none', color: '#fff', borderRadius: '8px', cursor: disabled ? 'default' : 'pointer', fontWeight: '600', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", opacity: disabled ? 0.5 : 1 });
const label = { fontSize: '12px', fontWeight: '600', color: '#6B7A8D' };

const MSG_SUGERIDA = 'Oi{nome}! Aqui é o Léo, assistente virtual da Autop Motos. Você tinha perguntado sobre a {modelo} — acabou de chegar uma aqui na loja. Quer que eu te mande as fotos?';

const formatarData = (d) => d ? new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
const formatarPrevisao = (d) => d ? new Date(d).toLocaleString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
const formatarFone = (t) => {
  const n = String(t || '').replace(/^55/, '');
  return n.length === 11 ? `(${n.slice(0, 2)}) ${n.slice(2, 7)}-${n.slice(7)}` : t;
};
const renderizar = (tpl, modelo, c) => tpl
  .replace(/\{nome\}/g, c?.primeiro_nome ? ` ${c.primeiro_nome}` : '')
  .replace(/\{modelo\}/g, modelo).trim();

const STATUS_COR = {
  pendente: ['#FFF6E5', '#B26A00'], enviando: ['#E6F1FB', '#185FA5'], enviado: ['#EAF5EE', '#2D7D4F'],
  erro: ['#FDECEA', '#C0392B'], cancelado: ['#F0F2F5', '#6B7A8D'], optout: ['#F0F2F5', '#6B7A8D'],
};
const Pill = ({ children, cor }) => (
  <span style={{ display: 'inline-block', padding: '2px 9px', borderRadius: '20px', fontSize: '11px', fontWeight: '600', background: cor[0], color: cor[1], whiteSpace: 'nowrap' }}>{children}</span>
);

export default function Remarketing() {
  const [termo, setTermo] = useState('');
  const [dias, setDias] = useState(60);
  const [buscando, setBuscando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [selecionados, setSelecionados] = useState(new Set());
  const [modelo, setModelo] = useState('');
  const [mensagem, setMensagem] = useState(MSG_SUGERIDA);
  const [enviando, setEnviando] = useState(false);
  const [fila, setFila] = useState(null);
  const [msg, setMsg] = useState(null);
  const [exportando, setExportando] = useState(false);

  const carregarFila = useCallback(() => {
    api.get('/whatsapp/remarketing/fila').then(r => setFila(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    carregarFila();
    const id = setInterval(carregarFila, 30000);
    return () => clearInterval(id);
  }, [carregarFila]);

  const buscar = async (e) => {
    e?.preventDefault();
    const t = termo.trim();
    if (t.length < 2) return;
    setBuscando(true); setMsg(null); setResultado(null);
    try {
      const r = await api.get('/whatsapp/remarketing/buscar', { params: { termo: t, dias } });
      setResultado(r.data);
      setModelo(m => m || t);
      // Pré-seleciona só quem o Léo atende (transferido = humano no controle) e não está na fila.
      setSelecionados(new Set(r.data.contatos.filter(c => !c.transferido && !c.na_fila).map(c => c.telefone)));
    } catch (err) {
      setMsg({ tipo: 'erro', texto: err.response?.data?.error || 'Erro na busca' });
    } finally { setBuscando(false); }
  };

  const contatos = resultado?.contatos || [];
  const selecionaveis = contatos.filter(c => !c.na_fila);
  const todosMarcados = selecionaveis.length > 0 && selecionaveis.every(c => selecionados.has(c.telefone));
  const alternar = (tel) => setSelecionados(s => { const n = new Set(s); n.has(tel) ? n.delete(tel) : n.add(tel); return n; });
  const alternarTodos = () => setSelecionados(todosMarcados ? new Set() : new Set(selecionaveis.map(c => c.telefone)));
  const escolhidos = contatos.filter(c => selecionados.has(c.telefone) && !c.na_fila);
  const transferidosEscolhidos = escolhidos.filter(c => c.transferido).length;

  const enviar = async () => {
    if (!escolhidos.length || !mensagem.trim()) return;
    if (mensagem.includes('{modelo}') && !modelo.trim()) { setMsg({ tipo: 'erro', texto: 'Preencha o modelo (usado em {modelo})' }); return; }
    setMsg(null);
    let previsao = null;
    try { previsao = (await api.get('/whatsapp/remarketing/fila', { params: { adicionar: escolhidos.length } })).data.previsao_com_adicionais; } catch { /* segue sem previsão */ }
    const aviso = [
      `Enviar para ${escolhidos.length} contato(s)?`,
      `Previsão de término: ${formatarPrevisao(previsao)}`,
      `(1 mensagem a cada 40–70s, máx. ${fila?.limite_diario || 40}/dia, só em horário comercial)`,
      transferidosEscolhidos ? `\nAtenção: ${transferidosEscolhidos} estão transferidos — o Léo NÃO responde esses, a resposta fica pro time.` : '',
      `\nExemplo: "${renderizar(mensagem, modelo.trim(), escolhidos[0])}"`,
    ].join('\n');
    if (!window.confirm(aviso)) return;
    setEnviando(true);
    try {
      const r = await api.post('/whatsapp/remarketing/enviar', {
        contatos: escolhidos.map(c => ({ telefone: c.telefone, numero: c.numero, jid: c.jid, nome: c.nome, primeiro_nome: c.primeiro_nome })),
        mensagem: mensagem.trim(), modelo: modelo.trim(), termo: resultado.termo,
      });
      const d = r.data;
      setMsg({ tipo: 'ok', texto: `${d.adicionados} envio(s) na fila${d.ja_na_fila ? ` · ${d.ja_na_fila} já estavam na fila` : ''}${d.optout ? ` · ${d.optout} opt-out ignorado(s)` : ''}.` });
      setFila(d.fila);
      setResultado(res => res && ({ ...res, contatos: res.contatos.map(c => selecionados.has(c.telefone) ? { ...c, na_fila: true } : c) }));
      setSelecionados(new Set());
    } catch (err) {
      setMsg({ tipo: 'erro', texto: err.response?.data?.error || 'Erro ao enviar' });
    } finally { setEnviando(false); }
  };

  // Baixa TODOS os contatos da busca atual (não só os marcados); o backend já exclui opt-out.
  const exportar = async () => {
    setExportando(true); setMsg(null);
    try {
      const r = await api.get('/whatsapp/remarketing/exportar', { params: { termo: resultado.termo, dias: resultado.dias }, responseType: 'blob' });
      const nome = (r.headers['content-disposition'] || '').match(/filename="([^"]+)"/)?.[1] || `remarketing-${resultado.termo}.xlsx`;
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = nome;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (err) {
      let texto = 'Erro ao exportar';
      try { texto = JSON.parse(await err.response.data.text()).error || texto; } catch (_) {}
      setMsg({ tipo: 'erro', texto });
    } finally { setExportando(false); }
  };

  const cancelarFila = async () => {
    if (!window.confirm(`Cancelar os ${fila?.pendentes || 0} envio(s) pendente(s)?`)) return;
    try {
      const r = await api.post('/whatsapp/remarketing/fila/cancelar');
      setMsg({ tipo: 'ok', texto: `${r.data.cancelados} envio(s) cancelado(s).` });
      carregarFila();
    } catch (err) { setMsg({ tipo: 'erro', texto: err.response?.data?.error || 'Erro ao cancelar' }); }
  };

  return (
    <div>
      <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533', marginBottom: '8px' }}>Remarketing</div>
      <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '18px' }}>
        Encontre quem perguntou de um modelo no WhatsApp e avise que chegou. Quando o cliente responder, o Léo atende normalmente.
        Quem pedir pra parar ("pare", "sair", "não me mande mais") sai da lista para sempre.
      </div>

      {msg && (
        <div style={{ padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', background: msg.tipo === 'ok' ? '#EAF5EE' : '#FDECEA', color: msg.tipo === 'ok' ? '#2D7D4F' : '#C0392B', fontSize: '13px', fontWeight: '500' }}>
          {msg.texto}
        </div>
      )}

      {/* Status da fila */}
      {fila && (
        <div style={{ ...card, display: 'flex', gap: '22px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={label}>Fila:</span>
          <span style={{ fontSize: '13px' }}><b>{fila.enviados}</b> enviados</span>
          <span style={{ fontSize: '13px' }}><b>{fila.pendentes}</b> pendentes</span>
          {fila.erros > 0 && <span style={{ fontSize: '13px', color: '#C0392B' }}><b>{fila.erros}</b> com erro</span>}
          <span style={{ fontSize: '13px', color: '#6B7A8D' }}>Hoje: {fila.tentados_hoje}/{fila.limite_diario}</span>
          <span style={{ fontSize: '13px', color: fila.dentro_horario ? '#2D7D4F' : '#B26A00' }}>{fila.dentro_horario ? '● Horário comercial' : '● Fora do horário (pausado)'}</span>
          {fila.pendentes > 0 && <span style={{ fontSize: '13px', color: '#6B7A8D' }}>Término previsto: {formatarPrevisao(fila.previsao_termino)}</span>}
          <span style={{ flex: 1 }} />
          {fila.pendentes > 0 && <button onClick={cancelarFila} style={btn('#C0392B')}>Cancelar pendentes</button>}
          <button onClick={carregarFila} style={{ ...btn('transparent'), color: '#1A3A5C', border: '1px solid rgba(26,58,92,0.2)' }}>↻</button>
        </div>
      )}

      {/* Busca */}
      <form onSubmit={buscar} style={{ ...card, display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={label}>Termo:</span>
        <input value={termo} onChange={e => setTermo(e.target.value)} placeholder="ex: XRE, Bros, NewJet" style={{ ...inpStyle, width: '220px' }} />
        <span style={label}>Últimos</span>
        <input type="number" min="1" max="180" value={dias} onChange={e => setDias(Math.min(180, Math.max(1, parseInt(e.target.value, 10) || 1)))} style={{ ...inpStyle, width: '75px' }} />
        <span style={label}>dias</span>
        <button type="submit" disabled={buscando || termo.trim().length < 2} style={btn('#1A3A5C', buscando || termo.trim().length < 2)}>
          {buscando ? 'Buscando… (pode levar ~10s)' : 'Buscar'}
        </button>
      </form>

      {resultado && (
        <>
          <div style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
              <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533' }}>
                {resultado.total} contato(s) mencionaram “{resultado.termo}” nos últimos {resultado.dias} dias
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                <div style={{ fontSize: '12px', color: '#9AA3AE' }}>
                  {resultado.mensagens_analisadas} mensagens analisadas
                  {resultado.sem_telefone > 0 && ` · ${resultado.sem_telefone} sem número identificável`}
                  {resultado.excluidos_optout > 0 && ` · ${resultado.excluidos_optout} opt-out excluídos`}
                </div>
                {contatos.length > 0 && (
                  <button type="button" onClick={exportar} disabled={exportando} style={btn('#1A6DFF', exportando)}>
                    {exportando ? 'Gerando…' : 'Baixar lista (Excel)'}
                  </button>
                )}
              </div>
            </div>
            {contatos.length === 0 ? (
              <div style={{ padding: '20px', textAlign: 'center', color: '#9AA3AE', fontSize: '13px' }}>Ninguém mencionou esse termo no período.</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={th}><input type="checkbox" checked={todosMarcados} onChange={alternarTodos} /></th>
                      {['Contato', 'Mencionou em', 'Trecho', 'Última msg', 'Status'].map(h => <th key={h} style={th}>{h}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {contatos.map(c => (
                      <tr key={c.telefone} style={{ opacity: c.na_fila ? 0.55 : 1 }}>
                        <td style={td}><input type="checkbox" disabled={c.na_fila} checked={selecionados.has(c.telefone) && !c.na_fila} onChange={() => alternar(c.telefone)} /></td>
                        <td style={{ ...td, whiteSpace: 'nowrap' }}>
                          <div style={{ fontWeight: '500' }}>{c.nome || '—'}</div>
                          <div style={{ fontSize: '12px', color: '#6B7A8D' }}>{formatarFone(c.telefone)}</div>
                        </td>
                        <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', whiteSpace: 'nowrap' }}>{formatarData(c.mencao_em)}</td>
                        <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', maxWidth: '360px' }}>{c.trecho}</td>
                        <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', whiteSpace: 'nowrap' }}>{formatarData(c.ultima_mensagem_em)}</td>
                        <td style={{ ...td, whiteSpace: 'nowrap' }}>
                          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                            {c.transferido ? <Pill cor={['#FFF6E5', '#B26A00']}>Transferido</Pill> : <Pill cor={['#E6F1FB', '#185FA5']}>Léo atende</Pill>}
                            {c.na_fila && <Pill cor={STATUS_COR.pendente}>Na fila</Pill>}
                            {c.ultimo_remarketing_em && <Pill cor={STATUS_COR.cancelado}>Remarketing {formatarData(c.ultimo_remarketing_em).slice(0, 5)}</Pill>}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {contatos.length > 0 && (
            <div style={card}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px', flexWrap: 'wrap' }}>
                <span style={label}>Modelo na mensagem ({'{modelo}'}):</span>
                <input value={modelo} onChange={e => setModelo(e.target.value)} placeholder="ex: XRE 300" style={{ ...inpStyle, width: '220px' }} />
              </div>
              <div style={{ ...label, marginBottom: '6px' }}>Mensagem (variáveis: {'{nome}'} e {'{modelo}'})</div>
              <textarea value={mensagem} onChange={e => setMensagem(e.target.value)} rows={3} maxLength={1000}
                style={{ ...inpStyle, width: '100%', resize: 'vertical' }} />
              {escolhidos[0] && (
                <div style={{ fontSize: '12px', color: '#6B7A8D', margin: '8px 0 12px' }}>
                  Prévia: <i>“{renderizar(mensagem, modelo.trim(), escolhidos[0])}”</i>
                </div>
              )}
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                <button onClick={enviar} disabled={enviando || !escolhidos.length || !mensagem.trim()} style={btn('#2D7D4F', enviando || !escolhidos.length || !mensagem.trim())}>
                  {enviando ? 'Enfileirando…' : `Enviar para selecionados (${escolhidos.length})`}
                </button>
                {transferidosEscolhidos > 0 && (
                  <span style={{ fontSize: '12px', color: '#B26A00' }}>{transferidosEscolhidos} transferido(s) selecionado(s): o Léo não responde esses — a resposta fica pro time.</span>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {/* Últimos envios */}
      {fila?.ultimos?.length > 0 && (
        <div style={card}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '12px' }}>Últimos envios</div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>{['Contato', 'Modelo', 'Status', 'Criado', 'Enviado', 'Obs.'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {fila.ultimos.map(u => (
                <tr key={u.id}>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{u.nome || formatarFone(u.numero)}</td>
                  <td style={td}>{u.modelo}</td>
                  <td style={td}><Pill cor={STATUS_COR[u.status] || STATUS_COR.cancelado}>{u.status}</Pill></td>
                  <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', whiteSpace: 'nowrap' }}>{formatarData(u.criado_em)}</td>
                  <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', whiteSpace: 'nowrap' }}>{formatarData(u.enviado_em)}</td>
                  <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', maxWidth: '260px' }}>{u.erro}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
